import { apiRequest } from '../../apiCall'

export const getBankGatewaysRequest = () => apiRequest('charge.getGateways');
export const getMinimumAmountRequest = () => apiRequest('charge.getMinimumChargeAmount');
export const getVatPercentRequest = () => apiRequest('charge.getVatPercent');
export const getCurrentCustomerCreditAmount = () => apiRequest('customerCredit.getCurrentCustomerCreditAmount');
export const postMakeChargeRequest = (params) => apiRequest('charge.makeCharge', { ...params }, '', true);
export const prepareForGatewayToMakeChargeRequest = (params) => apiRequest('charge.prepareForGatewayToMakeCharge', { ...params }, '', true);